import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userBookmarks: [],
        userFollowings: [],
        userPostsLikes: [],
        userPostsBookMark:[],
        orderCount: null,
        token: null,
        role:null,
        isLoggedIn:false,
        isShowSplash:false,
        hashtags:[],
        productsList:[]

    },
    getters: {
        getUserBookmarks(state) {
            return state.userBookmarks
        },
        getUserFollowings(state) {
            return state.userFollowings
        },
        getUserPostsLikes(state) {
            return state.userPostsLikes
        },
        getUserPostsBookMark(state) {
            return state.userPostsBookMark
        },
        getOrderCount(state) {
            return state.orderCount
        },
        getToken(state) {
            return state.token
        },
        getIsLoggedIn(state) {
            return state.isLoggedIn
        },
        getIsShowSplash(state) {
            return state.isShowSplash
        },
        getRole(state) {
            return state.role
        },
        getHashtags(state) {
            return state.hashtags
        },
        getProductsList(state) {
            return state.productsList
        },

    },
    mutations: {
        setIsShowSplash(state, isShowSplash) {
            state.isShowSplash = isShowSplash
        },
        setIsLoggedIn(state, isLoggedIn) {
            state.isLoggedIn = isLoggedIn
        },
        setToken(state, token) {
            state.token = token
        },
        setRole(state, role) {
            state.role = role
        },
        addUserBookmark(state, item) {
            state.userBookmarks = item
        },
        addUserFollowing(state, item) {
            state.userFollowings = item
        },
        addUserPostsLikes(state, item) {
            state.userPostsLikes = item
        },
        addUserPostsBookMarks(state, item) {
            state.userPostsBookMark = item
        },
        addOrRemoveBookmarkItemToList(state, id) {
            if (state.userBookmarks.find(x => x.RelationID === id) !== undefined) {
                state.userBookmarks = state.userBookmarks.filter(x => x.RelationID !== id)
            } else {
                state.userBookmarks.push({RelationID: id})
            }
        },
        addOrRemoveFollowingItemToList(state, id) {
            if (state.userFollowings.find(x => x.VendorID === id) !== undefined) {
                state.userFollowings = state.userFollowings.filter(x => x.VendorID !== id)
            } else {
                state.userFollowings.push({VendorID: id})
            }
        },
        addOrRemovePostBookMarkItemToList(state, id) {
            if (state.userPostsBookMark.find(x => x.VendorSocialNetworkID === id) !== undefined) {
                state.userPostsBookMark = state.userFollowings.filter(x => x.VendorSocialNetworkID !== id)
            } else {
                state.userPostsBookMark.push({VendorSocialNetworkID: id})
            }
        },
        addProductToCart(state) {
            if(state.token !== null && this.state.token !== undefined && state.token !== '' && state.role === 4) {
                let myHeaders = new Headers();
                myHeaders.append("Authorization", state.token);
                myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


                let requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    redirect: 'follow'
                };

                let resStatus = null
                fetch("https://pwa.eyvankhaneh.app/Shopping/CurrentBag", requestOptions)
                    .then(response => {
                        resStatus = response.status
                        return response.text()
                    })
                    .then(result => {
                        if (resStatus === 200) {
                            let json = JSON.parse(result)
                            state.orderCount = json.ListShoppingView.length
                        } else {
                            state.orderCount = '0'
                        }
                    })
                    .catch(() => console.log('1'));
            }

        },
        getProductList(){
            let requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };

            fetch("https://pwa.eyvankhaneh.app/Shopping/GetActiveProducts", requestOptions)
                .then(response => response.text())
                .then(result => {
                    this.state.productsList = JSON.parse(result)
                })
                .catch(error => console.log('error', error));
        },
        getHashtags(){
            let requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };

            fetch("https://pwa.eyvankhaneh.app/SearchSocialNetwork/GetHashTags", requestOptions)
                .then(response => response.text())
                .then(result =>{
                    this.state.hashtags= JSON.parse(result)
                })
                .catch(error => console.log('error', error));
        }

    },
    actions: {},
    modules: {}
})
